import { connect } from "react-redux";
import { RootState, TypedDispatch } from "../../../../redux/store";
import {
  LeadAutomationInitialStateDTO,
  SettingsInitialStateDTO,
} from "../service/types";

import LeadAutomation from "../components/Automation/LeadAutomation";
import {
  changeLeadAutomationStatus,
  deleteLeadAutomationConfig,
  editLeadAutomationConfig,
  getLeadAutomation,
  saveLeadAutomationConfig,
} from "../service/LeadAutomationSlice";
import CreateLeadAutomationForm from "../components/Automation/LeadManagement/CreateLeadAutomationForm";

interface DispatchProps {
  GetLeadAutomation(id: string): void;
  ChangeLeadAutomationStatus(body: any): void;
  SaveLeadAutomationConfig(body: any): void;
  UpdateLeadAutomationConfig(body: any): void;
  DeleteLeadAutomationConfig(body: any): void;
}

const mapStateToProps = (state: RootState): LeadAutomationInitialStateDTO => {
  return {
    getSavedLeadAutomationLoading:
      state.leadAutomation.getSavedLeadAutomationLoading,
    getSavedLeadAutomationSuccess:
      state.leadAutomation.getSavedLeadAutomationSuccess,
    getSavedLeadAutomationError:
      state.leadAutomation.getSavedLeadAutomationError,
    getSavedLeadAutomationData: state.leadAutomation.getSavedLeadAutomationData,
    changeLeadAutomationStatusLoading:
      state.leadAutomation.changeLeadAutomationStatusLoading,
    changeLeadAutomationStatusSuccess:
      state.leadAutomation.changeLeadAutomationStatusSuccess,
    changeLeadAutomationStatusError:
      state.leadAutomation.changeLeadAutomationStatusError,
    saveLeadAutomationConfigLoading:
      state.leadAutomation.saveLeadAutomationConfigLoading,
    saveLeadAutomationConfigSuccess:
      state.leadAutomation.saveLeadAutomationConfigSuccess,
    saveLeadAutomationConfigError:
      state.leadAutomation.saveLeadAutomationConfigError,
    editLeadAutomationConfigLoading:
      state.leadAutomation.editLeadAutomationConfigLoading,
    editLeadAutomationConfigSuccess:
      state.leadAutomation.editLeadAutomationConfigSuccess,
    editLeadAutomationConfigError:
      state.leadAutomation.editLeadAutomationConfigError,
    deleteLeadAutomationConfigLoading:
      state.leadAutomation.deleteLeadAutomationConfigLoading,
    deleteLeadAutomationConfigSuccess:
      state.leadAutomation.deleteLeadAutomationConfigSuccess,
    deleteLeadAutomationConfigError:
      state.leadAutomation.deleteLeadAutomationConfigError,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetLeadAutomation: (id: string) => {
      dispatch(getLeadAutomation(id));
    },
    ChangeLeadAutomationStatus: (body: any) => {
      dispatch(changeLeadAutomationStatus(body));
    },
    SaveLeadAutomationConfig: (body: any) => {
      dispatch(saveLeadAutomationConfig(body));
    },
    UpdateLeadAutomationConfig: (body: any) => {
      dispatch(editLeadAutomationConfig(body));
    },
    DeleteLeadAutomationConfig: (body: any) => {
      dispatch(deleteLeadAutomationConfig(body));
    },
  };
};

export interface LeadAutomationProps
  extends LeadAutomationInitialStateDTO,
    DispatchProps {}
export const LeadAutomationComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadAutomation);
export const CreateLeadAutomationComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateLeadAutomationForm);
